import { LcmsApiUtil } from '@/shared/api';

export const getDataImportLcms = {
    postMetaSearch: (param: API.MetaSearch.Req) => {
        return LcmsApiUtil.post<API.MetaSearch.Res>('/api/system/meta/search', param);
    },

    postStudyMap: (param: API.StudyMap.Req) => {
        return LcmsApiUtil.post<API.StudyMap.Res>('/api/system/meta/search/studyMap', param);
    },

    getDescendants: (mapCode: string) => {
        return LcmsApiUtil.get<API.Descendants.Res>(
            '/api/system/meta/descendants/' + mapCode,
            null
        );
    },

    postSetSearchEx: (param: API.SetSearchEx.Req) => {
        return LcmsApiUtil.post<API.SetSearchEx.Res>('/api/contents/setSearchEx', param);
    },

    postArticleSearchEx: (param: API.ArticleSearchEx.Req) => {
        return LcmsApiUtil.post<API.ArticleSearchEx.Res>('/api/contents/articleSearchEx', param);
    },

    postArticleCount: (param: API.ArticleCount.Req) => {
        return LcmsApiUtil.post<API.ArticleCount.Res>('/api/vivasam/articleDifficultyInfo', param);
    },

    postSetForSave: (param: API.SetForSave.Req) => {
        return LcmsApiUtil.post<API.SetForSave.Res>('/api/contents/setForSave', param);
    },

    postSetSummaryForSave: (param: API.SetSummaryForSave.Req) => {
        return LcmsApiUtil.post<API.SetSummaryForSave.Res>(
            '/api/contents/setSummaryForSave',
            param
        );
    },
    postSetMetaInfo: (param: API.SetMetaInfo.Req) => {
        return LcmsApiUtil.post<API.SetMetaInfo.Res>('/api/vivasam/setMetaInfo', param);
    },

    postArticleInfo: (param: API.ArticleInfo.Req) => {
        return LcmsApiUtil.post<API.ArticleInfo.Res>('/api/contents/articleInfo', param);
    },

    postArticleMetaInfo: (param: API.ArticleMetaInfo.Req) => {
        return LcmsApiUtil.post<API.ArticleMetaInfo.Res>('/api/vivasam/articleMetaInfo', param);
    },

    postContentsCopySet: (param: API.CopySet.Req) => {
        return LcmsApiUtil.post<API.CopySet.Res>('/api/contents/copySet', param);
    },
};
